import pluralize from 'pluralize';
import { memo } from 'react';

import { ConfirmationModal } from '@air/component-confirmation-modal';
import { type InputFile } from '@air/component-upload-dropzone';

import { UPLOAD_VERSIONS_MODAL } from '~/constants/testIDs';

export type UploadVersionsModalProps = {
  // https://linear.app/air/issue/ENG-113/update-uploadversionsmodalprops-to-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpload: (...anything: any) => void;
  // https://linear.app/air/issue/ENG-113/update-uploadversionsmodalprops-to-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCancel: (...anything: any) => void;
  files?: InputFile[];
} & AirModalProps;

export const UploadVersionsModal = memo(({ onUpload, onCancel, files }: UploadVersionsModalProps) => {
  return (
    <ConfirmationModal
      id="upload-versions-modal"
      isOpen
      data-testid={UPLOAD_VERSIONS_MODAL}
      onDismiss={onCancel}
      title={`Upload ${pluralize('version', (files && files.length) || 0, true)}?`}
      description={`You are about to upload ${pluralize('version', (files && files.length) || 0, true)} to this asset.`}
      ctaPrimaryText="Upload"
      onConfirm={onUpload}
    />
  );
});

UploadVersionsModal.displayName = 'UploadVersionsModal';
